<template>
  <div :class="upcomingEventSectionClasses">
    <span class="szw-font-semibold szw-text-base szw-text-center">
      {{ props.date }}
    </span>

    <div class="szw-p-1 szw-bg-white/10 szw-rounded-lg szw-text-center">
      <span>{{ props.time }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  date: {
    type: String,
    default: ''
  },
  time: {
    type: String,
    default: ''
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  }
})

const baseClasses = ['szw-flex szw-flex-col szw-items-center szw-text-nowrap szw-gap-2']
const upcomingEventSectionClasses = computed(() => [...baseClasses, props.isSmallWidgetContainerSize ? 'szw-mx-2' : 'szw-mx-4'])
</script>
